import { all, takeEvery, put, fork } from "redux-saga/effects";
import { push } from "react-router-redux";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* loadHomeRestaurantRecommeded() {
  yield takeEvery(actionTypes.HOME_RECOMMENDED_RESTAURANT, function* (action) {
    try {
      const response = yield API.loadRestaurant(action.data);
      if (response.data.success) {
        yield put(actions.loadHomeRecommededResSuccess(response.data));
      } else {
        // console.log(
        //   "Fail to load home recommeded restaurant",
        //   response.data.message
        // );
      }
    } catch (error) {
      //   console.log(
      //     "Fail to load home recommeded restaurant",
      //     actions.handleAPIError(error, "")
      //   );
      yield put(
        actions.handleAPIError(error, "Fail to load home recommeded restaurant")
      );
    }
  });
}

export function* loadRestaurant() {
  yield takeEvery(actionTypes.LOAD_RESTAURANT, function* (action) {
    try {
      let useES = action.data.keyword ? true : false;
      const response = useES
        ? yield API.SearchByES(action.data)
        : yield API.loadRestaurant(action.data);

      if (response.data.success) {
        let esList = {};
        if (useES) {
          esList.data = {
            result: response.data.data.result,
          };
          esList.total = response.data.data.total_rest;
        }
        yield put(
          actions.loadRestaurantSuccess(
            useES ? esList : response.data,
            action.pagination,
            action.data
          )
        );
      } else {
        alert(response.data.message);
        yield put(actions.loadRestaurantFail());
      }
    } catch (error) {
      alert(
        "Fail to load restaurant. " +
          (error && error.message ? "Error: " + error.message : "")
      );
      yield put(actions.handleAPIError(error, "Fail to get load restaurant."));
      yield put(actions.loadRestaurantFail());
    }
  });
}

export function* loadDeliveryAnnouncement() {
  yield takeEvery(actionTypes.LOAD_DELIVERY_ANNOUNCEMENT, function* (action) {
    try {
      const response = yield API.getDeliveryAnnouncement(action.data);
      if (response.data.success) {
        yield put(actions.loadDeliveryAnnouncementSuccess(response.data));
      } else {
        yield put(actions.loadDeliveryAnnouncementFail());
      }
    } catch (error) {
      yield put(actions.loadDeliveryAnnouncementFail());
    }
  });
}

export function* getRestaurantDetail() {
  yield takeEvery(actionTypes.GET_RESTAURANT_DETAIL, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.getRestaurantDetail(action.id);
      if (response.data.success) {
        yield put(actions.getRestaurantDetailSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to get restaurant detail." + response.data.message
        );
        yield put(actions.getRestaurantDetailFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to get restaurant detail.")
      );
      yield put(push("/restaurant/list"));
      yield put(actions.getRestaurantDetailFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* loadRestaurantAlbum() {
  yield takeEvery(actionTypes.LOAD_RESTAURANT_ALBUM, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.loadRestaurantAlbum(
        action.restID,
        action.album,
        action.offset,
        action.limit
      );
      if (response.data.success) {
        yield put(actions.loadRestaurantAlbumSuccess(response.data.data));
      } else {
        // console.log(
        //   "Warning: Fail to get restaurant album." + response.data.message
        // );
        yield put(actions.loadRestaurantAlbumFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      //   console.log(
      //     API.constructErrMsg(
      //       "Error: Fail to get restaurant album. \n" + action.error
      //     )
      //   );
      yield put(actions.loadRestaurantAlbumFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* checkRestaurantCoverage() {
  yield takeEvery(actionTypes.CHECK_RESTAURANT_COVERAGE, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.checkRestaurantCoverage(action.data);
      if (response.data.success) {
        yield put(actions.checkRestaurantCoverageSuccess(response.data.data));
      } else {
        yield put(actions.checkRestaurantCoverageFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      //   console.log(
      //     API.constructErrMsg(
      //       "Error: Fail to check restaurant coverage. \n" + action.error
      //     )
      //   );
      yield put(actions.checkRestaurantCoverageFail());
      yield put(actions.disableLoading());
    }
  });
}

// General
export function* getShopLOLOLID() {
  yield takeEvery(actionTypes.GET_SHOP_LOLOL_ID, function* (action) {
    try {
      const response = yield API.getShopLololID(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getShopLololLIDSuccess());
        yield put(actions.storeLOLOLID(response.data.data.lolol_id));
      } else {
        yield put(actions.getShopLololLIDFail());
      }
    } catch (error) {
      //   console.log(
      //     API.constructErrMsg(
      //       "Error: Fail to get shop LOLOL ID. \n" + action.error
      //     )
      //   );
      yield put(actions.getShopLololLIDFail());
    }
  });
}

export function* getStateList() {
  yield takeEvery(actionTypes.GET_STATE_LIST, function* (action) {
    try {
      const response = yield API.getStateList(action.state, action.district);
      if (response.data.success) {
        yield put(actions.getStateListSuccess(response.data.data));
      } else {
        alert("Warning: Fail to register device. " + response.data.message);
        yield put(actions.getStateListFail());
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to get state list."));
      yield put(actions.getStateListFail());
    }
  });
}

export function* getDeliveryFee() {
  yield takeEvery(actionTypes.GET_DELIVERY_FEE, function* () {
    try {
      const response = yield API.getDeliveryFee();
      if (response.data.success) {
        yield put(actions.getDeliveryFeeSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getDeliveryFeeFail());
      }
    } catch (error) {
      alert("Fail to get delivery fee.");
      yield put(actions.handleAPIError(error, "Fail to get delivery fee."));
      yield put(actions.getDeliveryFeeFail());
    }
  });
}

export function* getRestaurantFilterList() {
  yield takeEvery(actionTypes.GET_RESTAURANT_FILTER_LIST, function* (action) {
    try {
      const response = yield API.getRestaurantFilterList(action.data);
      if (response.data.success) {
        yield put(
          actions.getRestaurantFilterListSuccess(
            action.data,
            response.data.data
          )
        );
      } else {
        alert(
          "Warning: Fail to get restaurant filter list. " +
            response.data.message
        );
        yield put(actions.getRestaurantFilterListFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to get restaurant filter list.")
      );
      yield put(actions.getRestaurantFilterListFail());
    }
  });
}

export function* checkPaymentCode() {
  yield takeEvery(actionTypes.CHECK_PAYMENT_CODE, function* (action) {
    try {
      const response = yield API.checkPaymentCode(action.data);
      if (response.data.success && response.data.data) {
        yield put(
          actions.checkPaymentCodeSuccess(action.data, response.data.data)
        );
      } else {
        alert("Warning: Fail to verify payment code.\n" + response.message);
        yield put(actions.checkPaymentCodeFail());
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to verify payment code."));
      yield put(actions.checkPaymentCodeFail());
    }
  });
}

export function* updateViewCount() {
  yield takeEvery(actionTypes.UPDATE_VIEW_COUNT, function* (action) {
    try {
      const response = yield API.updateViewCount(action.data);
      if (response.data.success) {
        yield put(actions.updateViewCountSuccess());
      } else {
        // console.log(
        //   API.constructErrMsg(
        //     "Warning: Fail to update view count.\n" + action.error
        //   )
        // );
        yield put(actions.updateViewCountFail());
      }
    } catch (error) {
      //   console.log(
      //     API.constructErrMsg(
      //       "Error: Fail to update view count.\n" + action.error
      //     )
      //   );
      yield put(actions.updateViewCountFail());
    }
  });
}

export default function* restaurantSaga() {
  yield all([
    fork(loadHomeRestaurantRecommeded),
    fork(loadRestaurant),
    fork(loadDeliveryAnnouncement),
    fork(getRestaurantDetail),
    fork(loadRestaurantAlbum),
    fork(checkRestaurantCoverage),
    fork(getShopLOLOLID),
    // General
    fork(getStateList),
    fork(getDeliveryFee),
    fork(getRestaurantFilterList),
    fork(checkPaymentCode),
    fork(updateViewCount),
  ]);
}
